import { useState, useMemo } from 'react';
import { useEffect } from 'react';
import DataGrid from 'react-data-grid';
import { useDispatch } from 'react-redux';
import NumberFormat from 'react-number-format';

function CustomDataGrid(props) {
    const dispatch = useDispatch();
    const defaultProps = {
        defaultColumnOptions:{
            sortable: true,
            resizable: true
        },
        style: {minHeight:'600px'},
        columns: [],
        rows: [],
    }
    props = {...defaultProps,...props};

    let [rows, setRows] = useState([]);
    let [columns, setColumns] = useState([]);
    const [sortColumns, setSortColumns] = useState([]);
    let interval = false;

    const sortedRows = useMemo(() => {
        if (sortColumns.length === 0) return rows;
    
        return [...rows].sort((a, b) => {
          for (const sort of sortColumns) {
            const comparator = getComparator(sort.columnKey);
            const compResult = comparator(a, b);
            if (compResult !== 0) {
              return sort.direction === 'ASC' ? compResult : -compResult;
            }
          }
          return 0;
        });
      }, [rows, sortColumns]);

      function getComparator(sortColumn) {
        return (a, b) => {
            return a[sortColumn].localeCompare(b[sortColumn]);
        };
      }      

    useEffect(() => {
        loadData();
        if(props.timeOutRefresh){
            interval = setInterval(()=>{
                loadData(false);
            },props.timeOutRefresh*1000);
        }

        return () => {
            clearInterval(interval);
        };
    }, []);

    const loadData = async (showLoading=true) => {
        if(props.loadData){
            if(showLoading){
                dispatch({ type: 'SHOW_LOADING', value: true });
            }
            let response = await props.loadData();
            dispatch({ type: 'SHOW_LOADING', value: false });
            setColumns(response.columns);
            setRows(response.rows);
        } else {
            setColumns(props.columns);
            setRows(props.rows);            
        }
    }

    return (
        <div style={{padding:'10px'}}>
            <p><b>Total:</b> <NumberFormat value={rows.length} displayType={'text'} thousandSeparator={true} /></p>
            <DataGrid       
                defaultColumnOptions={props.defaultColumnOptions} 
                sortColumns={sortColumns}
                onSortColumnsChange={setSortColumns}
                columns={columns} rows={sortedRows} style={props.style}
                />
        </div>
    );
}
export default CustomDataGrid;
